class ThemeSlider extends HTMLElement {
  min; max; valueMin; valueMax; step; labelMin; labelMax; inputMin; inputMax;

  constructor(){
    super();
    this.init();
  }

  init = () => {
    this.min = parseInt(this.dataset.min);
    this.max = parseInt(this.dataset.max);
    this.valueMin = parseInt(this.dataset.valueMin);
    this.valueMax = parseInt(this.dataset.valueMax);
    this.labelMin = document.querySelector(this.dataset.labelMin);
    this.labelMax = document.querySelector(this.dataset.labelMax);
    this.inputMin = this.querySelector('[data-input-min]');
    this.inputMax = this.querySelector('[data-input-max]');
    this.step = this.max / 20;

    noUiSlider.create(this, {
      start: [this.valueMin, this.valueMax],
      range: {min: this.min, max: this.max},
      step: this.step,
    });

    if(this.labelMin && this.labelMax){
      this.noUiSlider.on('update', (values) => {
        this.labelMin.innerHTML = Utils.money(values[0]);
        this.labelMax.innerHTML = Utils.money(values[1]);
      });
    }

    this.noUiSlider.on('change', (values) => {
      console.log(values);
      this.inputMin.value = parseInt(values[0]/100);
      this.inputMax.value = parseInt(values[1]/100);
      window.dispatchEvent(new CustomEvent(Utils.RANGE_CHANGED, { detail: {
        min: values[0],
        max: values[1]
      }}));
    });
  }
}
if (!window.customElements.get("theme-slider")) {
  window.customElements.define("theme-slider", ThemeSlider);
}
  